import { Grid, Text } from '@mantine/core';
import { ORBIT_GRAY } from '@/theme/colors';

interface DetailRowProps {
  label: string;
  value: string;
}

// Per content-table canon: label 13px / 0.55 black / 400 Regular,
// content 14px / full Black / 400 Regular. Bold only for true emphasis
// (unread / flag / alert) — set at the call site, not the default here.
// Vertical-align top so multi-line content grows the row downward instead
// of pushing the label off-center.
export function DetailRow({ label, value }: DetailRowProps) {
  if (!value) return null;

  return (
    <Grid align="flex-start" style={{ width: '100%' }}>
      <Grid.Col span={3}>
        <Text style={{ fontSize: 13, lineHeight: '16px', color: ORBIT_GRAY }}>{label}</Text>
      </Grid.Col>
      <Grid.Col span={9}>
        <Text style={{ fontSize: 14, lineHeight: '20px', fontWeight: 400, color: 'var(--mantine-color-black)' }}>
          {value}
        </Text>
      </Grid.Col>
    </Grid>
  );
}
